import { z } from 'zod';

import { isMoney, type Money } from '@nucleus-commerce/core';

const KEY = /^[a-z][a-z0-9_]*$/;
const moneyValue = z.custom<Money>(isMoney).nullable();

export const paymentMethodFormSchema = z
  .object({
    key: z
      .string()
      .trim()
      .min(1, { error: 'paymentMethods:validation.keyRequired' })
      .max(40, { error: 'paymentMethods:validation.keyLength' })
      .regex(KEY, { error: 'paymentMethods:validation.keyFormat' }),
    name: z
      .string()
      .trim()
      .min(1, { error: 'paymentMethods:validation.nameRequired' })
      .max(120, { error: 'paymentMethods:validation.nameLength' }),
    description: z
      .string()
      .trim()
      .max(500, { error: 'paymentMethods:validation.descriptionLength' }),
    instructions: z
      .string()
      .trim()
      .max(4000, { error: 'paymentMethods:validation.instructionsLength' }),
    fee: moneyValue,
    minOrder: moneyValue,
    maxOrder: moneyValue,
    isActive: z.boolean(),
    position: z.coerce
      .number<string | number>()
      .int({ error: 'paymentMethods:validation.position' })
      .min(0, { error: 'paymentMethods:validation.position' }),
  })
  .refine((v) => !v.minOrder || !v.maxOrder || v.minOrder.amount <= v.maxOrder.amount, {
    path: ['minOrder'],
    error: 'paymentMethods:validation.minAboveMax',
  });

export type PaymentMethodFormInput = z.input<typeof paymentMethodFormSchema>;
export type PaymentMethodFormOutput = z.output<typeof paymentMethodFormSchema>;
